import { ArrowLeftIcon } from '../../icons';
import { BasicFrameConfig } from 'InternalLibrary';
import { Link } from '../../atoms';
import classes from 'classnames';
import classNames from 'classnames';
import layout from 'scss/layout.module.scss';
import LogoutButton from '../LogoutButton/LogoutButton';
import React, { memo } from 'react';
import styles from './SimpleNavbar.module.scss';
import translate from 'utils/translate';

export interface SimpleNavbarProps extends BasicFrameConfig {
  backBtnHidden?: boolean;
  className?: string;
}

export const SimpleNavbar = memo(
  ({
    className,
    frameContent: { goBack },
    logo,
    logoSquare,
    logoutClassName,
    headerLayout = 'default',
    hideLogo = false,
    hideLogout = false,
    onLogoutButtonClick,
    onBackBtnHandler,
    backBtnHidden = false,
  }: SimpleNavbarProps) => {
    const BackLink = goBack && onBackBtnHandler && (
      <Link
        className={classes(styles['back-link'], backBtnHidden && styles.hidden)}
        leftIcon={<ArrowLeftIcon />}
        onClick={backBtnHidden ? undefined : onBackBtnHandler}
      >
        <span className={styles['back-link-text']}>{goBack}</span>
      </Link>
    );
    return (
      <>
        {/* Mobile */}
        {!hideLogo && (
          <div className={classNames(styles['mobile-wrapper'])}>
            {BackLink}
            {logoSquare}
          </div>
        )}

        {/* Desktop */}
        <div
          className={classNames(
            styles['body-wrapper'],
            headerLayout === 'centered' && styles[headerLayout],
          )}
        >
          <div
            className={classNames(
              styles.body,
              layout['full-width-border-box'],
              headerLayout && styles[`body-layout-${headerLayout}`],
            )}
          >
            {/* Left (flex fix for centered logo) */}
            <div
              className={classNames(
                styles['left-flex'],
                hideLogout && styles['hidden'],
              )}
            >
              {BackLink}
            </div>

            {/* Logo */}
            {!hideLogo && (
              <div className={styles['desktop-logo-wrapper']}>{logo}</div>
            )}

            {/* Logout Button */}
            {!hideLogout && (
              <div className={styles['logout-button-wrapper']}>
                <LogoutButton
                  onClick={onLogoutButtonClick}
                  className={classes(styles['logout-button'], logoutClassName)}
                >
                  {translate('common.logout')}
                </LogoutButton>
              </div>
            )}
          </div>
        </div>
      </>
    );
  },
);
